import { RequestCounties } from "../dtos/transmed/county";
import { RequestReviewsByCounty } from "../dtos/transmed/review";
import Server from "./index";

export default class TransmedServer extends Server {
  constructor() {
    super("/transmed.php");
  }

  public get(params: RequestCounties | RequestReviewsByCounty): Promise<any> {
    return super.get(params);
  }
}
